import { Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { SuppliersTableRow } from '../../types/suppliersTableRow'
import { SuppliersTableNoDataField } from '../SuppliersTableNoDataField'

interface SuppliersTableCountryCellProps {
  row: SuppliersTableRow
}

export const SuppliersTableCountryCell = ({ row }: SuppliersTableCountryCellProps): ReactElement => {
  if (row.country === null || row.country === '') {
    return <SuppliersTableNoDataField />
  }

  return <Typography.Text>{row.country}</Typography.Text>
}
